var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "grm-slider-component" }, [
    _c("input", {
      ref: "input",
      staticClass: "grm-slider",
      style: _vm.inputStyle,
      attrs: { type: "range", min: _vm.min, max: _vm.max, step: _vm.step },
      domProps: { value: _vm.value },
      on: {
        touchstart: _vm.onEvent,
        touchend: _vm.onEvent,
        pointerdown: _vm.onEvent,
        pointerup: _vm.onEvent,
        mousedown: _vm.onEvent,
        mouseup: _vm.onEvent,
        input: _vm.onEvent,
        change: _vm.onEvent,
      },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }